import { styled } from 'styled-components'

// const checkmarks = '☑️✔️✅✓✔︎'

const Box = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(p) => p.theme.border};
  border-radius: 4px;
  background-color: ${(p) => p.theme.background};
  width: 20px;
  height: 20px;
  vertical-align: middle;
  text-align: center;
  line-height: 1;
  color: ${(p) => p.theme.highlight};
`

const Check = styled.span`
  opacity: ${(p) => (p.hidden ? '0.5' : '1')};
  line-height: 1;
  font-size: 16px;
`
const Checkbox = ({ value, onChange }) => {
  const handleChange = () => onChange(!value)

  return (
    <Box onClick={handleChange}>
      <Check hidden={!value}>{'›' || '✓'}</Check>
    </Box>
  )
}

export default Checkbox
